<template>
    <div>
        <div
            ref="dropdowns"
            class="dropdowns"
            tabindex="-1"
        >
            <radio-buttons
                list-heading="App.RadioButtonListHeader.SelectTopic"
                :radio-button-list="radioButtonList"
                :default-radio-button="selectedRadioButtonData.labelText"
                :sub-topic="subTopic"
                :select-by-url="true"
                @selected-radio-button="handleSelectedRadioButtonTopic"
                @radio-buttons-changed="handleRadioButtonsChanged"
            />
        </div>
        <div
            v-show="showRadiobuttonsTransmitterLocation"
            class="dropdowns"
        >
            <radio-buttons
                :key="forceUpdateKey"
                list-heading="App.RadioButtonListHeader.TVJaRadio.ValitseLahetinPaikkakunta"
                :radio-button-list="radioButtonListTransmitterLocation"
                :default-radio-button="selectedRadioButtonTransmitterLocation.labelText"
                :whitelist-subjects="false"
                @selected-radio-button="handleSelectedRadioButtonTransmitterLocation"
            />
            <multiselect
                ref="transmitterLocationSelect"
                :disabled="selectedRadioButtonTransmitterLocation.radioValue === ''"
                :checkbox-list="dropdownListTransmitterLocation"
                :input-id="'transmitterLocationFilter'"
                :placeholder="transmitterLocationPlaceholder"
                @selected-checkbox="addSelectedTransmitterLocation"
                @removed-checkbox="removeSelectedTransmitterLocation"
                @selected-checkboxes-change="selectedTransmitterLocationsChanged"
            />
        </div>
        <div class="dropdowns">
            <dropdowns
                v-show="showDropdownChannelPackage"
                list-heading="App.RadioButtonListHeader.TVJaRadio.ValitseKanavanippu"
                :dropdown-list="dropdownListChannelPackage"
                :default-item="dropdownListChannelPackage[0]"
                class="dropdowns"
                @selected-dropdown="handleSelectedDropdownChannelPackage"
            />
        </div>
        <div class="dropdowns">
            <dropdowns
                v-show="showDropdownRadioChannel"
                list-heading="App.RadioButtonListHeader.TVJaRadio.ValitseRadioKanava"
                :dropdown-list="dropdownListRadioChannel"
                :default-item="dropdownListRadioChannel[0]"
                class="dropdowns"
                @selected-dropdown="handleSelectedDropdownRadioChannel"
            />
        </div>
        <div class="dropdowns">
            <dropdowns
                v-show="showDropdownLicencee"
                list-heading="App.RadioButtonListHeader.TVJaRadio.ValitseLuvanhaltija"
                :dropdown-list="dropdownListLicensee"
                :default-item="dropdownListLicensee[0]"
                class="dropdowns"
                @selected-dropdown="handleSelectedDropDownLicensee"
            />
        </div>
        <div class="dropdowns">
            <dropdowns
                v-show="showDropdownRadioLicencee"
                list-heading="App.RadioButtonListHeader.TVJaRadio.ValitseLuvanhaltija"
                :dropdown-list="dropdownListRadioLicensee"
                :default-item="dropdownListRadioLicensee[0]"
                class="dropdowns"
                @selected-dropdown="handleSelectedDropDownRadioLicensee"
            />
        </div>
        <div
            v-show="showLocationSearch"
            class="search-components"
        >
            <search-address />
            <locate-me />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch, Prop } from "vue-facing-decorator"
    import RadioButtonListWithDropdown from "@/components/RadioButtonListWithDropdown.vue"
    import RadioButtonModel from "@/models/radiobuttonmodel"
    import DropdownList from "@/components/DropdownList.vue"
    import DropDownListModel from "@/models/dropdownlistmodel"
    import CheckboxSelectList from "@/components/CheckboxSelectList.vue"
    import SearchAddress from "@/components/SearchAddress.vue"
    import LocateMeLink from "@/components/LocateMeLink.vue"
    import ApiService from "@/services/ApiService"
    import SearchResultModel from "@/models/searchresultmodel"
    import LatLngPoint from "@/models/latlngpoint"
    import { store } from '@/store/store'

    @Component({
        components: {
            "radio-buttons": RadioButtonListWithDropdown,
            "locate-me": LocateMeLink,
            "search-address": SearchAddress,
            multiselect: CheckboxSelectList,
            dropdowns: DropdownList
        }
    })
    export default class TVJaRadio extends Vue {
        @Prop({ type: String }) subTopic!: string

        $refs!: {
            transmitterLocationSelect: CheckboxSelectList
            dropdowns: HTMLDivElement
        }

        apiService: ApiService = new ApiService(store.getters.baseHref)

        // DataPublishServices rajapintakutsun etuosa
        apiCallBasePart: string = "v1/TVJaRadio/"

        radioButtonList: Array<RadioButtonModel> = this.radioButtonListTopics
        radioButtonListTransmitterLocation: Array<RadioButtonModel> = this.radioButtonListTransmitterLocationTopics
        // Valittu radiobutton tietoineen
        selectedRadioButtonData: RadioButtonModel = this.defaultRadioButton
        selectedRadioButtonTransmitterLocation: RadioButtonModel = this.radioButtonListTransmitterLocation[0]
        // Dropdownlistat
        dropdownListChannelPackages : string[] = []
        dropdownListTransmitterLocationsTV: string[] = []
        dropdownListLicenseesTV: string[] = []

        dropdownListTransmitterLocationsRadio: string[] = []
        dropdownListLicenseesRadio: string[] = []
        dropdownListRadioChannels : string[] = []

        // Lähetinpaikkakuntalistat
        transmitterLocationsTV : string[] = []
        transmitterLocationsRadio : string[] = []

        // filtterit
        selectedTransmitterLocations : string[] = []
        selectedChannelPackage: string = ""
        selectedLicensee: string = ""
        selectedTVLicensee: string = ""
        selectedRadioLicensee: string = ""
        selectedRadioChannel: string = ""

        // coordinaatit
        coordX: string = ""
        coordY: string = ""

        pageName: string = "tvjaradio"

        forceUpdateKey = 0

        mounted(): void {
            store.dispatch("setSelectedSubjectRadioButton", this.selectedRadioButtonData)
        }

        async activated() {
            // tyhjännetään kartan edellinen lokaatiot
            store.dispatch("setStopLocate")
            store.dispatch("setCurrentPage", this.pageName)
            this.radioButtonList = this.radioButtonListTopics
            this.radioButtonListTransmitterLocation = this.radioButtonListTransmitterLocationTopics
            this.selectedRadioButtonData = this.defaultRadioButton
            this.selectedRadioButtonTransmitterLocation = this.radioButtonListTransmitterLocation[0]
            store.dispatch("setSelectedSubjectRadioButton", this.selectedRadioButtonData)

            // valintalistojen datat
            store.dispatch("setLoading", { name: this.pageName, value: true })
            this.dropdownListChannelPackages = await this.getDropdownListChannelPackages()
            this.dropdownListTransmitterLocationsTV = await this.getDropdownListTransmitterLocationsTV()
            this.dropdownListLicenseesTV = await this.getDropdownListLicenseesTV()
            this.dropdownListRadioChannels = await this.getDropdownListRadioChannels()
            this.dropdownListTransmitterLocationsRadio = await this.getDropdownListTransmitterLocationsRadio()
            this.dropdownListLicenseesRadio = await this.getDropdownListLicenseesRadio()
            store.dispatch("setLoading", { name: this.pageName, value: false })

            // Jos tullaan toiselta alueelta takaisin niin location marker on tyhjennetty ja poistetaan tässä tapauksessa myös koordinaatit ettei näytetä dataa tietylle paikalle.
            this.coordX = ""
            this.coordY = ""

            // Pakotetaan radiobuttoneiden päivitys, jotta oikea radiobutton näkyy varmasti valittuna
            this.forceUpdateKey += 1

            // Tehdään apikutsu, jolla haetaan kartan data
            await this.setDataToLoad()
        }

        deactivated() {
            this.radioButtonList = []
            this.selectedRadioButtonTransmitterLocation = this.radioButtonListTransmitterLocation[0]
            store.dispatch("setSubTopic", null)
            store.dispatch("setCurrentPage", "")
        }

        // ruutukoko
        get displayType(): string {
            return store.getters.displayType
        }

        async handleSelectedRadioButtonTopic(item: RadioButtonModel) {
            this.selectedRadioButtonData = item
            store.dispatch("setSelectedSubjectRadioButton", item)
            // tyhjennetään yhteiset lähetinpaikkakunta ja luvanhaltija fillterit kun vaihdetaan aihetta
            // #23795 jätetään valitut arvot
            // this.selectedTransmitterLocations = []
            // this.selectedLicensee = ""
            if (item.radioValue === "TVPeittoalueet") {
                this.selectedLicensee = this.selectedTVLicensee
            }
            if (item.radioValue === "RadioPeittoalueet") {
                this.selectedLicensee = this.selectedRadioLicensee
            }
            // Tehdään apikutsu, jolla haetaan kartan data
            await this.setDataToLoad()
        }

        handleRadioButtonsChanged(list: Array<RadioButtonModel>) {
            // Päivitä defaultina valittu radio button
            this.selectedRadioButtonData = list[0]
        }

        async handleSelectedRadioButtonTransmitterLocation(item: RadioButtonModel) {
            // lähetinpaikkakunta valinta tapahtuma
            this.selectedRadioButtonTransmitterLocation = item
            await this.setDataToLoad()
        }

        async handleSelectedDropdownChannelPackage(item: string) {
            // kanavanippu valinta
            this.selectedChannelPackage = item
            await this.setDataToLoad()
        }

        async handleSelectedDropdownRadioChannel(item: string) {
            // Radiokanava valinta
            this.selectedRadioChannel = item
            await this.setDataToLoad()
        }

        async handleSelectedDropDownLicensee(item: string) {
            // luvanhalija valinta
            this.selectedTVLicensee = item
            this.selectedLicensee = item
            await this.setDataToLoad()
        }

        async handleSelectedDropDownRadioLicensee(item: string) {
            // luvanhalija valinta
            this.selectedRadioLicensee = item
            this.selectedLicensee = item
            await this.setDataToLoad()
        }

        getFilters(): URLSearchParams {
            const filter = new URLSearchParams()

            switch (this.selectedRadioButtonData.radioValue) {
                case "TVPeittoalueet":
                    if (this.selectedTransmitterLocations.length > 0 && this.selectedRadioButtonTransmitterLocation.radioValue !== "") {
                        this.selectedTransmitterLocations.forEach(element => {
                            filter.append("lahetinKunta", this.getMunicipalityCode(element))
                        })
                    }
                    if (this.selectedChannelPackage !== "") {
                        filter.append("mux", this.selectedChannelPackage)
                    }
                    if (this.selectedLicensee !== "") {
                        filter.append("luvanhaltija", this.selectedLicensee)
                    }
                    return filter
                case "RadioPeittoalueet":
                    if (this.selectedTransmitterLocations.length > 0 && this.selectedRadioButtonTransmitterLocation.radioValue !== "") {
                        this.selectedTransmitterLocations.forEach(element => {
                            filter.append("lahetinKunta", this.getMunicipalityCode(element))
                        })
                    }
                    if (this.selectedRadioChannel !== "") {
                        filter.append("kanava", this.selectedRadioChannel)
                    }
                    if (this.selectedLicensee !== "") {
                        filter.append("luvanhaltija", this.selectedLicensee)
                    }
                    return filter
                case "AntenniTVSaatavuus":
                    if (this.coordX !== "") {
                        filter.append("koordinaattiX", this.coordX)
                    }
                    if (this.coordY !== "") {
                        filter.append("koordinaattiY", this.coordY)
                    }
                    return filter
                case "RadioasemienKuuluvuus":
                    if (this.coordX !== "") {
                        filter.append("koordinaattiX", this.coordX)
                    }
                    if (this.coordY !== "") {
                        filter.append("koordinaattiY", this.coordY)
                    }
                    return filter
                default:
                    return filter
            }
        }

        // Osoite haku
        get searchAddressSelected(): SearchResultModel {
            return store.getters.searchAddressSelected
        }

        @Watch("searchAddressSelected")
        async onSearchAddressSelected(): Promise<void> {
            if (this.searchAddressSelected) {
                this.coordX = this.searchAddressSelected.coordinates.lat.toString()
                this.coordY = this.searchAddressSelected.coordinates.lng.toString()
                await this.setDataToLoad()
            }
            else {
                this.coordX = ""
                this.coordY = ""
            }
        }

        get coordinates(): LatLngPoint {
            return store.getters.coordinates
        }

        @Watch("coordinates")
        async onCoordinatesChanged(): Promise<void> {
            if (this.coordinates) {
                this.coordX = this.coordinates.lat.toString()
                this.coordY = this.coordinates.lng.toString()
                await this.setDataToLoad()
            }
            else {
                this.coordX = ""
                this.coordY = ""
            }
        }

        get currentPage(): string {
            return store.getters.currentPage
        }

        get activeLang(): SearchResultModel {
            return store.getters.activeLang
        }

        @Watch("activeLang")
        async onActiveLang(): Promise<void> {
            // Päivitetään radio ja TV lähetin dropdownien listaukset valitun kielen mukaiseksi
            this.dropdownListTransmitterLocationsTV = await this.getDropdownListTransmitterLocationsTV()
            this.dropdownListTransmitterLocationsRadio = await this.getDropdownListTransmitterLocationsRadio()

            // Poistetaan kaikki valitut lähetinpaikkakunnat select-komponentista koska niiden kielitermejä ei voi kääntää lennosta
            this.$refs.transmitterLocationSelect.removeAllSelections()

            await this.setDataToLoad()
        }

        get defaultRadioButton(): RadioButtonModel {
            // Jos sivulle tullaan subTopic routen kautta, niin asetetaan default radiobutton value routen mukaisesti
            if (this.subTopic) {
                for (let i = 0; i < this.radioButtonList.length; i++) {
                    if (this.radioButtonList[i].radioValue === this.subTopic) {
                        return this.radioButtonList[i]
                    }
                }
            }
            return this.radioButtonList[0]
        }

        async setDataToLoad(): Promise<void> {
            if (this.currentPage !== this.pageName) {
                return
            }

            store.dispatch("setLoading", { name: this.pageName, value: true })

            // Asetetaan oikean slotin sisältö
            store.dispatch("setRightSlot", this.selectedRadioButtonData.radioValue)

            const filters = this.getFilters()
            const clearLocationMarker = store.getters.currentPage.toLowerCase() !== store.getters.dataUrlToLoad?.url?.split("/")[1]?.toLowerCase()
            // if ((this.selectedRadioButtonData.radioValue !== "AntenniTVSaatavuus" && this.selectedRadioButtonData.radioValue !== "RadioasemienKuuluvuus")
            //     || (this.selectedRadioButtonData.radioValue === "AntenniTVSaatavuus" && filters.get("koordinaattiX") && filters.get("koordinaattiY"))
            //     || (this.selectedRadioButtonData.radioValue === "RadioasemienKuuluvuus" && filters.get("koordinaattiX") && filters.get("koordinaattiY"))) {
            store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + this.selectedRadioButtonData.radioValue, type: this.selectedRadioButtonData.radioValue, params: filters, clearLocationMarker })
            // }

            store.dispatch("setLoading", { name: this.pageName, value: false })
        }

        async selectedTransmitterLocationsChanged(checkedList: string[]) {
            this.selectedTransmitterLocations = checkedList
            await this.setDataToLoad()
        }

        get leftSlotHeaderTieliikenne(): string | undefined {
            return this.$t("App.LeftSlot.Header.TVJaRadio")
        }

        get transmitterLocationPlaceholder(): string | undefined {
            return this.$t("App.TVJaRadio.CheckboxSelectList.Lahetinpaikkakunta.Placeholder")
        }

        // TODO TPa: tarkista radioValuet vs api, default value
        get radioButtonListTopics(): Array<RadioButtonModel> {
            return [new RadioButtonModel("App.TVJaRadio.RadioList.AntenniTVLahetintenPeittoalueet", "TVPeittoalueet"),
                    new RadioButtonModel("App.TVJaRadio.RadioList.RadiokanavienPeittoalueet", "RadioPeittoalueet"),
                    new RadioButtonModel("App.TVJaRadio.RadioList.AntenniTVSaatavuusTietyssaPaikassa", "AntenniTVSaatavuus"),
                    new RadioButtonModel("App.TVJaRadio.RadioList.RadioasemienKuuluvuusTietyssaPaikassa", "RadioasemienKuuluvuus")
            ]
        }

        get radioButtonListTransmitterLocationTopics(): Array<RadioButtonModel> {
            return [new RadioButtonModel("App.TVJaRadio.RadioList.Kaikki", ""),
                    new RadioButtonModel("App.TVJaRadio.RadioList.Lahetinpaikkakunta", "Lahetinpaikkakunta")
            ]
        }

        // TVLahetinKunnat
        async getDropdownListTransmitterLocationsTV() : Promise<string[]> {
            // Haetaan lähettimien kuntanumerot DataPublishServiceltä vain yhden kerran
            if (this.transmitterLocationsTV.length === 0) {
                this.transmitterLocationsTV = await this.apiService.dynamicApiCall(this.apiCallBasePart + "TVLahetinKunnat")
            }

            // Haetaan lokalisoitu kuntanimi kuntanumeron perusteella
            const list: string[] = []
            for (const element of this.transmitterLocationsTV) {
                list.push(this.getMunicipalityName(element))
            }
            return this.sortStringArray(list)
        }

        // RadioLahetinKunnat
        async getDropdownListTransmitterLocationsRadio() : Promise<string[]> {
            // Haetaan lähettimet DataPublishServiceltä vain yhden kerran
            if (this.transmitterLocationsRadio.length === 0) {
                this.transmitterLocationsRadio = await this.apiService.dynamicApiCall(this.apiCallBasePart + "RadioLahetinKunnat")
            }

            // Haetaan lokalisoitu kuntanimi kuntanumeron perusteella
            const list: string[] = []
            for (const element of this.transmitterLocationsRadio) {
                list.push(this.getMunicipalityName(element))
            }
            return this.sortStringArray(list)
        }

        // Järjestää listan aakkosten mukaan
        sortStringArray(list: string[]) : string[] {
            // Character mapissa skandit on järjestyksessä äåö kun aakkostuksessa åäö. Siirretään å ja Å ennen ä:tä.
            // Huomaa että tämä sort alla järjestää isot ennen pieniä, mutta isot skandit on pienten jälkeen.
            const mapCharacters = (str) => str.replace("å", "ß").replace("Å", "½")

            const sortFunc = (n1, n2) => {
                if (mapCharacters(n1) > mapCharacters(n2)) {
                    return 1
                }

                if (mapCharacters(n1) < mapCharacters(n2)) {
                    return -1
                }
                return 0
            }

            return list.sort(sortFunc)
        }

        getMunicipalityName(kuntanumero: string) : string {
            const municipalities = store.getters.municipalitiesData
            for (const municipality of municipalities) {
                if (municipality.kuntanumero === kuntanumero) {
                    if (store.getters.activeLang !== "sv") {
                        return municipality.nimi
                    }
                    else {
                        return municipality.namn
                    }
                }
            }
            return ""
        }

        getMunicipalityCode(kuntanimi: string) : string {
            const municipalities = store.getters.municipalitiesData
            for (const municipality of municipalities) {
                if (store.getters.activeLang !== "sv") {
                    if (municipality.nimi === kuntanimi) {
                        return municipality.kuntanumero
                    }
                }
                else {
                    if (municipality.namn === kuntanimi) {
                        return municipality.kuntanumero
                    }
                }
            }
            return ""
        }

        get dropdownListTransmitterLocation(): Array<DropDownListModel> {
            const dropdowns: DropDownListModel[] = []
            if (this.selectedRadioButtonData.radioValue === "TVPeittoalueet") {
                if (this.dropdownListTransmitterLocationsTV.length > 0) {
                    this.dropdownListTransmitterLocationsTV.forEach(element => {
                        dropdowns.push(new DropDownListModel(element, element, false))
                    })
                }
            }
            else { // radio
                if (this.dropdownListTransmitterLocationsRadio.length > 0) {
                    this.dropdownListTransmitterLocationsRadio.forEach(element => {
                        dropdowns.push(new DropDownListModel(element, element, false))
                    })
                }
            }
            return dropdowns
        }

        async getDropdownListChannelPackages() : Promise<string[]> {
            // kanavaniput/mux
            return await this.apiService.dynamicApiCall(this.apiCallBasePart + "TvMuxTunnisteet")
        }

        get dropdownListChannelPackage(): Array<DropDownListModel> {
            const dropdowns: DropDownListModel[] = []
            if (this.dropdownListChannelPackages.length > 0) {
                dropdowns.push(new DropDownListModel("App.TVJaRadio.RadioList.Kaikki", "", false))
                this.dropdownListChannelPackages.forEach(element => {
                    dropdowns.push(new DropDownListModel(element, element, false))
                })
            }
            return dropdowns
        }

        async getDropdownListRadioChannels() : Promise<string[]> {
            // kanavaniput/mux
            return await this.apiService.dynamicApiCall(this.apiCallBasePart + "RadioKanavat")
        }

        get dropdownListRadioChannel(): Array<DropDownListModel> {
            const dropdowns: DropDownListModel[] = []
            if (this.dropdownListRadioChannels.length > 0) {
                dropdowns.push(new DropDownListModel("App.TVJaRadio.RadioList.Kaikki", "", false))
                this.dropdownListRadioChannels.forEach(element => {
                    dropdowns.push(new DropDownListModel(element, element, false))
                })
            }
            return dropdowns
        }

        async getDropdownListLicenseesTV() : Promise<string[]> {
            // TVLuvanhaltijat
            return await this.apiService.dynamicApiCall(this.apiCallBasePart + "TVLuvanhaltijat")
        }

        async getDropdownListLicenseesRadio() : Promise<string[]> {
            // RadioLuvanhaltijat
            return await this.apiService.dynamicApiCall(this.apiCallBasePart + "RadioLuvanhaltijat")
        }

        get dropdownListLicensee(): Array<DropDownListModel> {
            const dropdowns: DropDownListModel[] = []
            if (this.dropdownListLicenseesTV.length > 0) {
                dropdowns.push(new DropDownListModel("App.TVJaRadio.RadioList.Kaikki", "", false))
                this.dropdownListLicenseesTV.forEach(element => {
                    dropdowns.push(new DropDownListModel(element, element, false))
                })
            }
            return dropdowns
        }

        get dropdownListRadioLicensee(): Array<DropDownListModel> {
            const dropdowns: DropDownListModel[] = []
            if (this.dropdownListLicenseesRadio.length > 0) {
                dropdowns.push(new DropDownListModel("App.TVJaRadio.RadioList.Kaikki", "", false))
                this.dropdownListLicenseesRadio.forEach(element => {
                    dropdowns.push(new DropDownListModel(element, element, false))
                })
            }
            return dropdowns
        }

        get showRadiobuttonsTransmitterLocation(): boolean {
            return this.selectedRadioButtonData.radioValue === "TVPeittoalueet" || this.selectedRadioButtonData.radioValue === "RadioPeittoalueet"
        }

        get showDropdownChannelPackage(): boolean {
            return this.selectedRadioButtonData.radioValue === "TVPeittoalueet"
        }

        get showDropdownRadioChannel(): boolean {
            return this.selectedRadioButtonData.radioValue === "RadioPeittoalueet"
        }

        get showDropdownLicencee(): boolean {
            return this.selectedRadioButtonData.radioValue === "TVPeittoalueet"
        }

        get showDropdownRadioLicencee(): boolean {
            return this.selectedRadioButtonData.radioValue === "RadioPeittoalueet"
        }

        get showLocationSearch(): boolean {
            return this.selectedRadioButtonData.radioValue !== "TVPeittoalueet" && this.selectedRadioButtonData.radioValue !== "RadioPeittoalueet"
        }
    }
</script>
<style scoped>
    .dropdowns {
        margin-bottom: 2.5rem;
    }
</style>
